import { styled, CardContent } from '@mui/material';
import { theme } from 'assets/themes/zizzi';

export const Content = styled(CardContent)`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 1rem 1.5rem;
  user-select: none;

  ${theme.breakpoints.up('sm')} {
    min-width: 541px;
  }

  ${theme.breakpoints.up('md')} {
    min-width: 600px;
  }
`;
